import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";


export const GET_HEADER = gql`
  query MyQuery {
    header {
      enabled
      locationComponent {
        contentItems {
          ... on Locations {
            locationImage {
              urls
            }
            locationUrl {
              text
              url
            }
            enabled
          }
        }
      }
      infoSectionComponent {
        contentItems {
          ... on InfoSection {
            image {
              urls
            }
            text
            enabled
          }
        }
      }
      logoImage {
        urls
      }
      logoUrl {
        text
        url
      }
      linkComponent {
        contentItems {
          ... on Links {
           enabled
            url {
              text
              url
            }
          }
        }
      }
    }
  }
`;


export async function fetchHeader() {
  const result = await apolloClient.query({
    query: GET_HEADER,
    fetchPolicy: "network-only",
  });

  return result.data;
}
